<nav class="navbar navbar-expand-md navbar-light d-flex d-md-none"><button class="navbar-toggler" data-target="#topbar" data-toggle="collapse" type="button" aria-controls="topbar" aria-label="Toggle navigation"><span class="navbar-toggler-icon"></span></button>
<div class="navbar-collapse" id="topbar">
  <ul class="navbar-nav">
    @for (l of links; track trackByFn(l)) {
      @for (i of l.items; track i) {
        <li class="nav-item v-nav-item fadeIn" routerLinkActive="active"><a class="nav-link" [routerLink]="[i.url]"><i class="lnr me-4" [ngClass]="i.icon"></i>{{ i.label | translate | titlecase }}@if (i.badge && i.badge > 0) {
        <span class="badge bg-danger ms-2">{{ i.badge }}</span>
      }</a></li>
    }
  }

  <li class="nav-item v-nav-item fadeIn"><a class="nav-link" [routerLink]="['/logout']"><i class="lnr lnr-exit"></i></a></li>
</ul>
</div>
</nav>

<div class="nav navbar d-none d-md-block p-0 w-100" id="sidebar">
  <nav class="navbar py-0 px-4">
    <ul class="navbar-nav nav nav-pills w-100 fadeIn">
      @if (!isProduction) {
        <li class="nav-item v-nav-item mt-4">
          <div class="alert alert-warning"><i class="lnr lnr-warning me-2"></i>{{ 'ENVIRONMENT' | translate : params }}</div>
        </li>
      }

      <div class="protected-sidebar-items pb-4" [ngClass]="{ 'mt-4': isProduction }">
        @for (l of links; track trackByFn(l)) {
          <li class="nav-item v-nav-item">
            <div class="nav-link fw-bold text-uppercase small text-dark">{{ ( l.label | translate ) | titlecase }}</div>
          </li>
          <div class="fadeIn">
            @for (i of l.items; track i; let last = $last) {
              <li class="nav-item v-nav-item" routerLinkActive="active" [attr.id]="i.step ? 'step' + i.step : ''" [attr.data-title]="'TOUR.STEP' + i.step + '.TITLE' | translate" [attr.data-intro]="'TOUR.STEP' + i.step + '.DESCRIPTION' | translate" [attr.data-hint]="'TOUR.STEP' + i.step + '.TITLE' | translate" [attr.data-step]="i.step" data-position="right" [ngClass]="{ 'mb-2': !last, 'mb-4': last }"><a class="nav-link px-4 p-2" [routerLink]="[i.url]"><span class="d-flex align-items-center w-100"><i class="lnr me-3" [ngClass]="i.icon"></i><span class="flex-grow-1">{{ ( i.label | translate ) | titlecase }}</span>@if (i.badge && i.badge > 0) {
              <span class="badge bg-danger ms-2">{{ i.badge }}</span>
            }</span></a></li>
          }
        </div>
      }
    </div>
  </ul>
</nav>
</div>
